/**
 * Generated by orval v7.2.0 🍺
 * Do not edit manually.
 * BVHI Product Data Platform
 * The backend service api is responsible for managing users, customer data, product catalogs, and api token.
 * OpenAPI spec version: 1.28.12
 */
import { useMutation, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import type {
  ApiErrorDTO,
  BadRequestResponse,
  CurrentUserDTO,
  DeleteSuccessDTO,
  ForbiddenResponse,
  InternalServerErrorResponse,
  NotFoundResponse,
  UnauthorizedResponse,
  UpdateCurrentUserDTO,
  UpdateEmailDTO,
  UpdatePasswordDTO,
  UpdateUsernameDTO,
} from "../../model";
import { customFetchInstance } from "../../../custom-fetch-instance";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * Returns the current user informations
 * @summary Returns the current user
 */
export type getCurrentUserResponse = {
  data: CurrentUserDTO;
  status: number;
};

export const getGetCurrentUserUrl = () => {
  return `http://localhost:8080/platform/v1/profile/current`;
};

export const getCurrentUser = async (
  options?: RequestInit
): Promise<getCurrentUserResponse> => {
  return customFetchInstance<Promise<getCurrentUserResponse>>(
    getGetCurrentUserUrl(),
    {
      ...options,
      method: "GET",
    }
  );
};

export const getGetCurrentUserQueryKey = () => {
  return [`http://localhost:8080/platform/v1/profile/current`] as const;
};

export const getGetCurrentUserQueryOptions = <
  TData = Awaited<ReturnType<typeof getCurrentUser>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCurrentUserQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentUser>>> = ({
    signal,
  }) => getCurrentUser({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentUser>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCurrentUserQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCurrentUser>>
>;
export type GetCurrentUserQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useGetCurrentUser<
  TData = Awaited<ReturnType<typeof getCurrentUser>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getCurrentUser>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof customFetchInstance>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetCurrentUser<
  TData = Awaited<ReturnType<typeof getCurrentUser>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getCurrentUser>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetCurrentUser<
  TData = Awaited<ReturnType<typeof getCurrentUser>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns the current user
 */

export function useGetCurrentUser<
  TData = Awaited<ReturnType<typeof getCurrentUser>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCurrentUserQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetCurrentUserSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getCurrentUser>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getCurrentUser>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCurrentUserQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentUser>>> = ({
    signal,
  }) => getCurrentUser({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getCurrentUser>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCurrentUserSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCurrentUser>>
>;
export type GetCurrentUserSuspenseQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useGetCurrentUserSuspense<
  TData = Awaited<ReturnType<typeof getCurrentUser>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(options: {
  query: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getCurrentUser>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetCurrentUserSuspense<
  TData = Awaited<ReturnType<typeof getCurrentUser>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getCurrentUser>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetCurrentUserSuspense<
  TData = Awaited<ReturnType<typeof getCurrentUser>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getCurrentUser>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns the current user
 */

export function useGetCurrentUserSuspense<
  TData = Awaited<ReturnType<typeof getCurrentUser>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getCurrentUser>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCurrentUserSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Updates the informations of the logged in user.

Can throw the following error codes:
`ERR_USERS_INVALID_ORGANISATION_NAME`, `ERR_USERS_NO_ORGANISATION_NAME` and ,`ERR_USERS_INVALID_ORGANISATION_CODE`.

Further explanation about the error codes can be found in the projects README.

 * @summary Updates the current user
 */
export type updateCurrentUserResponse = {
  data: CurrentUserDTO;
  status: number;
};

export const getUpdateCurrentUserUrl = () => {
  return `http://localhost:8080/platform/v1/profile/current`;
};

export const updateCurrentUser = async (
  updateCurrentUserDTO: UpdateCurrentUserDTO,
  options?: RequestInit
): Promise<updateCurrentUserResponse> => {
  return customFetchInstance<Promise<updateCurrentUserResponse>>(
    getUpdateCurrentUserUrl(),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateCurrentUserDTO),
    }
  );
};

export const getUpdateCurrentUserMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCurrentUser>>,
    TError,
    { data: UpdateCurrentUserDTO },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCurrentUser>>,
  TError,
  { data: UpdateCurrentUserDTO },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCurrentUser>>,
    { data: UpdateCurrentUserDTO }
  > = (props) => {
    const { data } = props ?? {};

    return updateCurrentUser(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCurrentUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCurrentUser>>
>;
export type UpdateCurrentUserMutationBody = UpdateCurrentUserDTO;
export type UpdateCurrentUserMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Updates the current user
 */
export const useUpdateCurrentUser = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCurrentUser>>,
    TError,
    { data: UpdateCurrentUserDTO },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCurrentUser>>,
  TError,
  { data: UpdateCurrentUserDTO },
  TContext
> => {
  const mutationOptions = getUpdateCurrentUserMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Deletes the current user. On success, the user gets logged out.
 * @summary Deletes the current user
 */
export type deleteCurrentUserResponse = {
  data: DeleteSuccessDTO;
  status: number;
};

export const getDeleteCurrentUserUrl = () => {
  return `http://localhost:8080/platform/v1/profile/current`;
};

export const deleteCurrentUser = async (
  options?: RequestInit
): Promise<deleteCurrentUserResponse> => {
  return customFetchInstance<Promise<deleteCurrentUserResponse>>(
    getDeleteCurrentUserUrl(),
    {
      ...options,
      method: "DELETE",
    }
  );
};

export const getDeleteCurrentUserMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | void
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCurrentUser>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCurrentUser>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCurrentUser>>,
    void
  > = () => {
    return deleteCurrentUser(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCurrentUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCurrentUser>>
>;

export type DeleteCurrentUserMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | void
  | InternalServerErrorResponse;

/**
 * @summary Deletes the current user
 */
export const useDeleteCurrentUser = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | void
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCurrentUser>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteCurrentUser>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getDeleteCurrentUserMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Updates username of the current user. On success, the user will be logged out.

The operation may throw one of the following error codes:
`ERR_USERS_INVALID_USERNAME`, `ERR_USERS_USERNAME_TAKEN`.

The username will be validated against the following regex expression in both, frontend and backend: `^(?=.{4,30}$)[\p{L}\p{N}@._-]+$`
If the username violates against this regex, the error code `ERR_USERS_INVALID_USERNAME` will be thrown.

Further explanation about the error codes can be found in the projects README.

 * @summary Update username of current user
 */
export type updateCurrentUserUsernameResponse = {
  data: CurrentUserDTO;
  status: number;
};

export const getUpdateCurrentUserUsernameUrl = () => {
  return `http://localhost:8080/platform/v1/profile/current/username`;
};

export const updateCurrentUserUsername = async (
  updateUsernameDTO: UpdateUsernameDTO,
  options?: RequestInit
): Promise<updateCurrentUserUsernameResponse> => {
  return customFetchInstance<Promise<updateCurrentUserUsernameResponse>>(
    getUpdateCurrentUserUsernameUrl(),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateUsernameDTO),
    }
  );
};

export const getUpdateCurrentUserUsernameMutationOptions = <
  TError =
    | ApiErrorDTO
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCurrentUserUsername>>,
    TError,
    { data: UpdateUsernameDTO },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCurrentUserUsername>>,
  TError,
  { data: UpdateUsernameDTO },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCurrentUserUsername>>,
    { data: UpdateUsernameDTO }
  > = (props) => {
    const { data } = props ?? {};

    return updateCurrentUserUsername(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCurrentUserUsernameMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCurrentUserUsername>>
>;
export type UpdateCurrentUserUsernameMutationBody = UpdateUsernameDTO;
export type UpdateCurrentUserUsernameMutationError =
  | ApiErrorDTO
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Update username of current user
 */
export const useUpdateCurrentUserUsername = <
  TError =
    | ApiErrorDTO
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCurrentUserUsername>>,
    TError,
    { data: UpdateUsernameDTO },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCurrentUserUsername>>,
  TError,
  { data: UpdateUsernameDTO },
  TContext
> => {
  const mutationOptions = getUpdateCurrentUserUsernameMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Updates e-mail of the current user. On success, the user will be logged out.

The operation may throw one of the following error codes:
`ERR_USERS_INVALID_EMAIL`.

Further explanation about the error codes can be found in the projects README.

 * @summary Update e-mail of current user
 */
export type updateCurrentUserEMailResponse = {
  data: CurrentUserDTO;
  status: number;
};

export const getUpdateCurrentUserEMailUrl = () => {
  return `http://localhost:8080/platform/v1/profile/current/email`;
};

export const updateCurrentUserEMail = async (
  updateEmailDTO: UpdateEmailDTO,
  options?: RequestInit
): Promise<updateCurrentUserEMailResponse> => {
  return customFetchInstance<Promise<updateCurrentUserEMailResponse>>(
    getUpdateCurrentUserEMailUrl(),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateEmailDTO),
    }
  );
};

export const getUpdateCurrentUserEMailMutationOptions = <
  TError =
    | ApiErrorDTO
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCurrentUserEMail>>,
    TError,
    { data: UpdateEmailDTO },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCurrentUserEMail>>,
  TError,
  { data: UpdateEmailDTO },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCurrentUserEMail>>,
    { data: UpdateEmailDTO }
  > = (props) => {
    const { data } = props ?? {};

    return updateCurrentUserEMail(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCurrentUserEMailMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCurrentUserEMail>>
>;
export type UpdateCurrentUserEMailMutationBody = UpdateEmailDTO;
export type UpdateCurrentUserEMailMutationError =
  | ApiErrorDTO
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Update e-mail of current user
 */
export const useUpdateCurrentUserEMail = <
  TError =
    | ApiErrorDTO
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCurrentUserEMail>>,
    TError,
    { data: UpdateEmailDTO },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCurrentUserEMail>>,
  TError,
  { data: UpdateEmailDTO },
  TContext
> => {
  const mutationOptions = getUpdateCurrentUserEMailMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Updates password of the current user. On success, the user gets logged out.

Can throw the following error codes:
`ERR_USERS_INVALID_PASSWORD`.

The password will be validated against the following regex expression in both, frontend and backend: `^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W)[A-Za-z\d\W]{12,}$`
If the password violates against this regex, the error code `ERR_USERS_INVALID_PASSWORD` will be thrown.

Further explanation about the error codes can be found in the projects README.

 * @summary Update password of current user
 */
export type updateCurrentUserPasswordResponse = {
  data: CurrentUserDTO;
  status: number;
};

export const getUpdateCurrentUserPasswordUrl = () => {
  return `http://localhost:8080/platform/v1/profile/current/password`;
};

export const updateCurrentUserPassword = async (
  updatePasswordDTO: UpdatePasswordDTO,
  options?: RequestInit
): Promise<updateCurrentUserPasswordResponse> => {
  return customFetchInstance<Promise<updateCurrentUserPasswordResponse>>(
    getUpdateCurrentUserPasswordUrl(),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updatePasswordDTO),
    }
  );
};

export const getUpdateCurrentUserPasswordMutationOptions = <
  TError =
    | ApiErrorDTO
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCurrentUserPassword>>,
    TError,
    { data: UpdatePasswordDTO },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCurrentUserPassword>>,
  TError,
  { data: UpdatePasswordDTO },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCurrentUserPassword>>,
    { data: UpdatePasswordDTO }
  > = (props) => {
    const { data } = props ?? {};

    return updateCurrentUserPassword(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCurrentUserPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCurrentUserPassword>>
>;
export type UpdateCurrentUserPasswordMutationBody = UpdatePasswordDTO;
export type UpdateCurrentUserPasswordMutationError =
  | ApiErrorDTO
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Update password of current user
 */
export const useUpdateCurrentUserPassword = <
  TError =
    | ApiErrorDTO
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCurrentUserPassword>>,
    TError,
    { data: UpdatePasswordDTO },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCurrentUserPassword>>,
  TError,
  { data: UpdatePasswordDTO },
  TContext
> => {
  const mutationOptions = getUpdateCurrentUserPasswordMutationOptions(options);

  return useMutation(mutationOptions);
};
